import { DatePipe } from "@angular/common";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { saveAs } from "file-saver";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import { ConfirmationService, MessageService } from "primeng/api";
import "rxjs/Rx";
import { environment } from "src/environments/environment";
import { MyserviceService } from "../myservice.service";
import * as moment from "moment";

@Component({
    selector: "app-warehouse-order-management",
    templateUrl: "./warehouse-order-management.component.html",
    styleUrls: ["./warehouse-order-management.component.css"],
    providers: [MessageService,ConfirmationService],
})
export class WarehouseOrderManagementComponent implements OnInit {
    badges = this.service.getStatusBadges();
    rowsNo = 10;
    offset:number = 0;
    pageSize:number = 10;
    noOfRecords: number=0;
    hasSearched=false;
    sortField: String="dateTimeReceived";
    sortOrder: number = -1;
    directionArray = [{ label: "Select", value: "-1" }, { label: "Inbound", value: "Inbound" }, { label: "Outbound", value: "Outbound" }]
    userRole: string;
    noRecords: boolean = false;
    document: any = {};
    searchData: any = [];
    detailInfoData: any = [];
    display: boolean;
    transactionArray = [];
    ackStatusArray = [];
    statusArray = [];
    correlationArray = [];
    parentWarehousesArray=[];
    warehousesArray = [];
    public show: boolean = false;
    public show1: boolean = false;
    public count = 0;
    selected;
    today = Date.now();
    shipId = "";
    checkMe = "";
    depositorOrderNumber = "";
    database = "";
    islifecycle = "";
    checked: boolean = false;
    isChecked: boolean = false;
    lifeCycleRestData: any = [];
    enableLifeCycle: boolean = false;
    lifeCycleHeaders: { field: string; header: string }[];
    tableHeaders: { field: string; header: string; width: string; }[];
    loader: boolean;
    valueType: string;
    correlationTypeDirection: boolean;
    correlationTypeDirection1: boolean;
    valueType1: string;
    correlationTypeDirection2: boolean;
    valueType2: string;
    resultMsg: string = "Limit exceeded. Cannot add more fields";
    selectedRow: any;
    mailPopup:boolean;
    roleId: any;
    displayPostTransDownload: boolean;
    mulPostTransData: any=[];
    postTransFilePath: any;
    instanceId: any;
    disableDownload: boolean=false;
    partnerArray: any=[];
    dateType :any
    dateTypeList = [
        {label : 'Custom Range' ,value: 'Custom Range'},
        {label : 'Last 30 Days' ,value: 'Last 30 Days'},
        {label : 'Last 7 Days' ,value: 'Last 7 Days'},
        {label : 'Today' ,value: 'Today'},
        {label : 'Yesterday' ,value: 'Yesterday'}
    ]
      alwaysShowCalendars: boolean;
      ranges: any = {
            'Today': [ moment().startOf('day'), moment().endOf('day') ],
            'Yesterday': [ moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
            'Last 7 Days': [ moment().subtract(6, 'days').startOf('day'), moment().endOf('day') ],
            'Last 30 Days': [ moment().subtract(29, 'days').startOf('day'), moment().endOf('day') ],
            'This Month': [ moment().startOf('month').startOf('day'), moment().endOf('month').endOf('day') ],
            'Last Month': [
              moment().subtract(1, 'month').startOf('month').startOf('day'),
              moment().subtract(1, 'month').endOf('month').endOf('day')      
            ]
          };
    displayPreTranslation: boolean;
    previewTranslation: any;
    filePath: any;
    
    constructor(
        private service: MyserviceService,
        private router: Router,
        public session: SessionStorageService,
        public localstorage: LocalStorageService,
        private http: HttpClient,
        public datepipe: DatePipe,
        public activatedRoute: ActivatedRoute,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
    ) { }

    ngOnInit() {
        this.getDropdownOptions();
        this.document.database="LIVE";
        this.userRole = this.session.retrieve("userRole");
        this.roleId = this.session.retrieve("UserDetails").roleId;
        this.islifecycle = this.activatedRoute.snapshot.paramMap.get("isback");

        this.tableHeaders = [
            { field: "", header: "#", width: "50px" },
            { field: "dateTimeReceived", header: "Date Time", width: "140px" },
            { field: "fileId", header: "Instance Id", width: "100px" },
            { field: "depositorOrderNumber", header: "Document #", width: "200px" },
            { field: "transactionType", header: "Transaction #", width: "120px" },
            { field: "isaControlNumber", header: "ISA CTRL", width: "100px" },
            { field: "partnerName", header: "Partner", width: "160px" },
            { field: "direction", header: "Direction", width: "100px" },
            { field: "ackStatus", header: "ACK/API Status", width: "130px" },
            { field: "parentWarehouse", header: "Division", width: "130px" },
            { field: "warehouse", header: "Warehouse", width: "100px" },
            { field: "reProcessStatus", header: "Reprocess", width: "120px" },
        ];
        if (!this.islifecycle) {
            this.setToDefault();
        } else {
            this.setWarehouseLifecycle();
        }
    }
    //This method is used to get Status, Ack Status, Correlation dropdown options
    getDropdownOptions() {
        this.statusArray = this.service.getStatus();
        this.ackStatusArray = this.service.getAckAndApiStatus();
        this.correlationArray = this.service.getcorrelation(
            this.localstorage.retrieve("token"),
            "All"
        );
    }

    onPagination(data) {
        this.rowsNo = data.first + data.rows >= this.noOfRecords ? this.noOfRecords : data.first + data.rows;
        //Checking if the previous pagination and sorting fields are different with latest fields or not to reduce the API hits
        if (data.first != this.offset || data.rows != this.pageSize || data.sortField != this.sortField || data.sortOrder != this.sortOrder) {
            this.offset = data.first;
            this.pageSize = data.rows;
            this.sortField = data.sortField;
            this.sortOrder = data.sortOrder;
            this.search();
        }
    }
    reprocess(){
        const data={
            "id":this.selectedRow.id,
            }
        // reprocessFile
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http
            .post(
                environment.apiUrl +
                    "/documentRepository/ReprocessRequest",data,
                { headers: headers }
            )
            .subscribe((data) => {
                this.search()
            });
    }
    close() {
        this.display = false;
    }

    addFilter() {
        if (this.count == 0) {
            this.show = true;
            this.count = this.count + 1;
        } else if (this.count == 1) {
            this.show1 = true;
            this.show = true;
            this.count = this.count + 1;
        } else {
            this.messageService.add({
                key: 'myKey1',
                severity: "warn",
                summary: "Warning",
                detail: this.resultMsg,

            })

        }
    }

    removeFilter() {
        this.document.corrAttribute1 = "-1";
        this.document.corrValue1 = "";
        if (this.count == 2) {
            this.show = false;
            this.count = this.count - 1;
        } else if (this.count == 1) {
            this.document.corrAttribute2 = "-1";
            this.document.corrValue2 = "";
            this.show1 = false;
            this.show = false;
            this.count = this.count - 1;
        } else {
            this.messageService.add({
                key: 'myKey1',
                severity: "warn",
                summary: "Warning",
                detail: this.resultMsg,
            })
        }
    }

    search(countFlag=false) {
        this.loader = true;
        this.searchData = [];
        this.document.flag = "search";
        if (
            (this.document.corrAttribute != "-1" &&
                this.document.corrValue == "" || this.document.corrValue == "-1")
        ) {
            this.loader = false;
            alert("Please enter Correlation Value !!");
            return false;
        }
        if (
            this.document.corrAttribute == "-1" &&
            this.document.corrValue != ""
        ) {
            this.loader = false;
            alert("Please select Correlation !!");
            return false;
        }
        if (
            this.document.corrAttribute1 != "-1" &&
            this.document.corrValue1 == "" || this.document.corrValue1 == "-1"
        ) {
            this.loader = false;
            alert("Please enter Correlation Value !!");
            return false;
        }
        if (
            this.document.corrAttribute1 == "-1" &&
            this.document.corrValue1 != ""
        ) {
            this.loader = false;
            alert("Please select Correlation !!");
            return false;
        }
        if (
            this.document.corrAttribute2 != "-1" &&
            this.document.corrValue2 == "" || this.document.corrValue2 == "-1"
        ) {
            this.loader = false;
            alert("Please enter Correlation Value !!");
            return false;
        }
        if (
            this.document.corrAttribute2 == "-1" &&
            this.document.corrValue2 != ""
        ) {
            this.loader = false;
            alert("Please select Correlation !!");
            return false;
        }
        this.document.limit=this.pageSize;
        this.document.offSet =this.offset;
        this.document.sortField=this.sortField;
        this.document.sortOrder= this.sortOrder == 1 ? "ASC" : "DESC";
         //To get list of partner names from array of objects
        let selectedPartners = []
        this.document.partnerName.map((e) => {
            selectedPartners.push(e.id)
        })
        this.document.fromDate = this.datepipe.transform(
            this.selected.startDate,
            "MM/dd/yyyy HH:mm"
        );
        this.document.toDate = this.datepipe.transform(
            this.selected.endDate,
            "MM/dd/yyyy HH:mm"
        );
        let reqBody={...this.document};
        reqBody.partnerName=this.service.multiSelectValue(this.partnerArray,selectedPartners);
        reqBody.parentWarehouse=this.service.multiSelectValue(this.parentWarehousesArray,reqBody.parentWarehouse);
        reqBody.warehouse=this.service.multiSelectValue(this.warehousesArray,reqBody.warehouse);
        reqBody.ackStatus = this.service.multiSelectValue(this.ackStatusArray, reqBody.ackStatus);
        let headers = new HttpHeaders();
        this.hasSearched=true;
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http
            .post(environment.apiUrl + "/warehouseOrder/search",{...reqBody,countFlag}, {
                headers: headers,
            })
            .subscribe((data:any) => {
                this.loader = false;
                this.localstorage.store("document", this.document);
                this.searchData = data.data;
                if (countFlag) {
                    this.noOfRecords = data.totalRecordsCount;
                }
                if (data.totalRecordsCount == 0) {
                    this.noRecords = true;
                }
            });
    }

    detailInfo(depositorOrderNumber, fileId, database) {
        this.instanceId=fileId;
        this.display = true;
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http
            .get(
                environment.apiUrl +
                "/warehouseOrder/detailInfo/" +
                depositorOrderNumber +
                "/" +
                fileId +
                "/" +
                database,
                { headers: headers }
            )
            .subscribe((data) => {
                this.detailInfoData = data;
                this.postTransFilePath=this.detailInfoData.postTransFilePath.split(',')
            });
    }

    export() {
        this.disableDownload=true;
        this.document.flag = "excel";
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        let selectedPartners = []
        this.document.partnerName.map((e) => {
            selectedPartners.push(e.id)
        })
        let {limit,offSet,...reqBody}=this.document;
        reqBody.partnerName=this.service.multiSelectValue(this.partnerArray,selectedPartners);
        reqBody.parentWarehouse=this.service.multiSelectValue(this.parentWarehousesArray,reqBody.parentWarehouse);
        reqBody.warehouse=this.service.multiSelectValue(this.warehousesArray,reqBody.warehouse);
        reqBody.countFlag = false;
        this.http
            .post(
                environment.apiUrl + "/warehouseOrder/download",
                reqBody,
                { responseType: "blob", headers: headers }
            )
            .subscribe(
                (response: any) => {
                    this.disableDownload=false;
                    var blob = new Blob([response], {
                        type: "application/vnd.ms-excel",
                    });
                    saveAs(
                        blob,
                        "WarehouseOrderReport_" +
                        this.datepipe.transform(this.service.getDateByTZ(), "ddMMyyyy_HHmm","+0000") +
                        ".xlsx"
                    );
                },
                (error) => {
                    this.disableDownload=false;
                    //console.log("Error occured" + error);
                }
            );
    }
    translationFileDownload(filePath) {
        // this.service.translationFileDownload(filePath);
        this.loader = true   
        this.service.translationFilePreview(filePath).subscribe((data: any) => {
            this.loader = false
            setTimeout(() => {
                this.previewTranslation = data;  
                this.displayPreTranslation = true; 
            }, 500);             
        });
        this.filePath = filePath
    }

    download(){
        this.service.translationFileDownload(this.filePath);
    }
    
    setDefaultPagination(){
        this.hasSearched = false;
        this.offset = 0;
        this.pageSize = 10;
        this.noOfRecords = 0;
        this.sortField = "dateTimeReceived";
        this.sortOrder = -1;
    }
    setToDefault() {
        this.setDefaultPagination();
        this.noRecords = false;
        this.document.database = "LIVE";
        let today = this.service.getDateByTZ();
        this.selected = {
            startDate: new Date(
                today.getUTCFullYear(),
                today.getUTCMonth(),
                today.getUTCDate(),
                0,
                0,
                0
            ),
            endDate: new Date(
                today.getUTCFullYear(),
                today.getUTCMonth(),
                today.getUTCDate(),
                23,
                59,
                0
            ),
        };
        this.dbChange("M", this.document.database);
        this.count = 0;
        this.show = false;
        this.show1 = false;
        this.document.transactionType = "-1";
        this.document.partnerName = [];
        this.document.receiverId = "-1";
        this.document.parentWarehouse = [];
        this.document.warehouse = [];
        this.document.ackStatus = [];
        this.document.status = "-1";
        this.document.corrAttribute = "-1";
        this.document.corrAttribute1 = "-1";
        this.document.corrAttribute2 = "-1";
        this.document.corrValue = "";
        this.document.corrValue1 = "";
        this.document.corrValue2 = "";
        this.searchData = [];
    }

    setWarehouseLifecycle() {
        let document = this.localstorage.retrieve("document");
        this.document = document;
        let fromDate = new Date(this.document.fromDate);
        let toDate = new Date(this.document.toDate);
        this.dbChange("M", this.document.database);
        this.selected = {
            startDate: new Date(
                fromDate.getFullYear(),
                fromDate.getMonth(),
                fromDate.getDate(),
                fromDate.getHours(),
                fromDate.getMinutes(),
                fromDate.getSeconds(),
            ),
            endDate: new Date(
                toDate.getFullYear(),
                toDate.getMonth(),
                toDate.getDate(),
                toDate.getHours(),
                toDate.getMinutes(),
                toDate.getSeconds(),
            ),
        };

        this.document.partnerName = document.partnerName;
        this.document.receiverId = document.receiverId;
        this.search(true);
    }
    getWarehousesForWms(parentWarehouse,database) {
        this.document.warehouse=[];
        this.warehousesArray = this.service.getWarehouses(
            this.localstorage.retrieve("token"),
            database,
            this.service.multiSelectValue(this.parentWarehousesArray,parentWarehouse)
        );       
    }
    dbChange(flowFlag, database) {
        //To get list of partners
        this.service.getPartners(
            this.localstorage.retrieve("token"),
            flowFlag,
            database
        ).subscribe((res) => {
            this.partnerArray = res;
        })
        this.parentWarehousesArray = this.service.getParentWarehouses(
            this.localstorage.retrieve("token"),
            flowFlag,
            database
        );
        this.getWarehousesForWms([],database);
        this.transactionArray = this.service.getWarehouseDocTypes(
            this.localstorage.retrieve("token"),
            database
        );
    }

    populated(depositorOrderNumber, database,data) {
        this.database = database;
        this.depositorOrderNumber = depositorOrderNumber;
        this.selectedRow=data;
        
    }

    warehouseLifecycle() {
        if (this.depositorOrderNumber == "" || this.database == "") {
            alert("please select one check box");
        } else {
            this.localstorage.store("partnerArray", this.partnerArray);
            this.localstorage.store("database", this.database);
            this.localstorage.store(
                "depositorOrderNumber",
                this.depositorOrderNumber
            );
            this.router.navigate(["/mscvp/warehouse-lifecycle"]);
        }
    }
    setValueType() {
        this.document.corrValue = "";
        this.correlationTypeDirection = (this.document.corrAttribute == "Direction") ? true : false;
        this.valueType = (this.document.corrAttribute == "Instance Id") ? "number" : "text";
    }
    setValueType1() {
        this.document.corrValue1 = "";
        this.correlationTypeDirection1 = (this.document.corrAttribute1 == "Direction") ? true : false;
        this.valueType1 = (this.document.corrAttribute1 == "Instance Id") ? "number" : "text";
    }
    setValueType2() {
        this.document.corrValue2 = "";
        this.correlationTypeDirection2 = (this.document.corrAttribute2 == "Direction") ? true : false;
        this.valueType2 = (this.document.corrAttribute2 == "Instance Id") ? "number" : "text";
    }
    confirmReprocess() {
        if (this.depositorOrderNumber == "" || this.database == "") {
            alert("please select one check box");
        } else {
        this.confirmationService.confirm({
            message: 'Are you sure that you want to reprocess?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            key: "positionDialog",
            accept: () => {
                this.reprocess()            },
            reject: () => {
            }
        });
    }
    }
    openMailDialog(){
        this.mailPopup=true;
    }
    showMultipostTransDownload(){
        this.displayPostTransDownload=true
        this.mulPostTransData=[];
        this.postTransFilePath.map((data)=>this.mulPostTransData.push({path:data,isSelected:false}))   
    }
    updateMultiFileDialog(data){
        (data=="false")?this.displayPostTransDownload=false:null;
    }
    //For showing loader on multiple post trans file download
    updateloaderVisibilty(data) {
        this.loader = data == "true" ? true : false;
    }
}
